import { Action, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from '@/app/ui/store'
import { DeviceManagerPresenter } from "../presenters/DeviceManagerPresenter";
import { container } from "tsyringe";
import { DeviceManager } from "@/domain/entities/DeviceManager";
import Vue from 'vue'

export interface DeviceManagerState {
  isLoading: boolean
  deviceManager: DeviceManager[]
}

@Module({ namespaced: true, store, name: 'device-manager', dynamic: true })
class DeviceManagerController extends VuexModule implements DeviceManagerState {
  private presenter: DeviceManagerPresenter = container.resolve(
    DeviceManagerPresenter
  )

  public isLoading = false
  public deviceManager: DeviceManager[] = []

  @Action({ rawError: true })
  public getList() {
    this.setLoading(true)

    this.presenter
      .getList()
      .then(res => {
        this.setDeviceManager(res)
      })
      .catch(error => {
        Vue.notify({
          title: 'Fetch List Device Manager Failed',
          text: [400, 422, 401].includes(error?.status)
            ? error?.error?.message?.id
            : 'Something wrong',
          type: 'error',
          duration: 5000,
        })
      })
      .finally(() => {
        this.setLoading(false)
      })
  }

  @Action({ rawError: true })
  public async logout(id: number): Promise<boolean> {
    this.setLoading(true)
    const result = await this.presenter
      .logout(id)
      .then(() => {
        return true
      })
      .catch(error => {
        Vue.notify({
          title: 'Logout Device Failed',
          text:
            error.status === 400 || error.status === 422 || error.status === 404
              ? error.error.message.en
              : 'Something wrong',
          type: 'error',
          duration: 5000,
        })
        return false
      })
      .finally(() => {
        this.setLoading(false)
      })
    return result
  }

  
  @Mutation
  private setDeviceManager(deviceManager: DeviceManager[]) {
    this.deviceManager = deviceManager
  }

  @Mutation
  public setLoading(bool: boolean) {
    this.isLoading = bool
  }

}

export default getModule(DeviceManagerController)